import { isEmpty, isString } from 'lodash';
import { FC, type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { MiddleSpinner } from '../../components';
import { evaluate } from '../../evaluator';
import { useTitle, useUiTemplate } from '../../hooks';
import { useAllowedRoutes } from '../../hooks/use-allowed-routes';
import { ErrorPage, NotFound } from '../errors';

interface TemplatedProps {
  portal: string;
}

export const Templated: FC<TemplatedProps> = ({ portal }): JSX.Element => {
  const { templateId } = useParams();
  const { template, loaded: templateLoaded } = useUiTemplate(templateId || '', {});
  const { t } = useTranslation(['common']);
  const [searchParams] = useSearchParams();
  const queryParams = Object.fromEntries(Array.from(searchParams.entries()));
  const allowedRoutes = useAllowedRoutes(portal);

  useTitle(isString(queryParams.title) ? queryParams.title : undefined);

  if (templateId && allowedRoutes && !allowedRoutes.includes(`/view/${templateId}`)) return <NotFound />;

  if (!templateLoaded) {
    return <MiddleSpinner />;
  }

  if (isEmpty(template)) {
    return <ErrorPage error={{ name: t('common:page.errors.not-found.title'), message: '' }} />;
  }

  return <>{evaluate(template, queryParams)}</>;
};
